import { Alert, Res } from '@/types'

import base from './base'

export const alertsApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getAlerts: builder.query<Alert[], void>({
      query: () => 'teachers/alerts',
      transformResponse: (res: Res<Alert[]>) => res.data,
      providesTags: ['Alerts'],
    }),

    readAlert: builder.mutation<void, string | number>({
      query: (id) => ({
        url: `teachers/alerts/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Alerts', 'Home'],
    }),
  }),
})

export const { useGetAlertsQuery, useReadAlertMutation } = alertsApi
